export const beforeEachRoute = () => Promise.resolve(true);
